// Detects common in-app browsers (Instagram, Facebook, TikTok, etc.). In these
// webviews an external OAuth redirect — our Google sign-in — often can't return to
// the same view, so the guest lands on a blank page after signing in. When we
// detect one we nudge them to open the order in the real browser instead.
export function isInAppBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const signatures = [
    'FBAN', 'FBAV', 'FB_IAB', 'Instagram', 'Messenger',
    'Line/', 'Twitter', 'musical_ly', 'BytedanceWebview', 'TikTok',
    'MicroMessenger', 'Snapchat', 'LinkedInApp', 'WhatsApp', 'Pinterest',
  ];
  return signatures.some((s) => ua.indexOf(s) !== -1);
}
